<template>
  <input type="hidden" name="_token" :value="csrfToken" />
</template>

<script setup lang="ts">
import { csrfToken } from "@/features/user/store";
</script>
